import React, { useCallback, useState } from "react";
import { FaX } from "react-icons/fa6";
import useEventState from "../../hooks/eventHooks";

function AddEvents({ setIsAddEventModalOpen, events, addEvent }) {
  const [event, setEvent] = useState({
    name: "",
    edition: "",
    poster: "",
    whatsapp_url: "",
  });

  const handleChange = (e) => {
    if (e.target.name === "poster") {
      setEvent({ ...event, [e.target.name]: e.target.files[0] });
    } else {
      setEvent({ ...event, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, edition, poster, whatsapp_url } = event;
    addEvent({ name, edition, poster, whatsapp_url });
    setEvent({
      name: "",
      edition: "",
      poster: "",
      whatsapp_url: "",
    });
    setIsAddEventModalOpen(false);
  };

  return (
    <div className="bg-bg-modal fixed w-screen h-screen top-0 left-0 overflow-hidden z-20">
      <div className="lg:w-4/12 w-11/12 lg:h-3/5 h-4/5 m-auto bg-white lg;mt-28 mt-8 rounded-xl relative">
        <div className="flex justify-between items-center p-3">
          <h3 className="text-xl capitalize">Add Event</h3>
          <FaX
            onClick={() => {
              setIsAddEventModalOpen(false);
            }}
            className="hover:cursor-pointer"
          />
        </div>
        <form onSubmit={handleSubmit}>
          {/* inputs */}
          <div className="p-6">
            <div className="flex flex-col">
              <label htmlFor="name" className="mb-1">
                Event Name
              </label>
              <input
                id="name"
                name="name"
                value={event.name}
                onChange={handleChange}
                className="border border-gray-70 rounded-lg h-10 w-72 p-2"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="edition" className="mb-1">
                Edition
              </label>
              <input
                id="edition"
                type="text"
                name="edition"
                onChange={handleChange}
                value={event.edition}
                className="border border-gray-70 rounded-lg h-10 w-72 p-2"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="whatsapp_url" className="mb-1">
                Whatsapp Link
              </label>
              <input
                id="whatsapp_url"
                type="url"
                name="whatsapp_url"
                onChange={handleChange}
                value={event.whatsapp_url}
                className="border border-gray-70 rounded-lg h-10 w-72 p-2"
              />
            </div>
            <div className="flex flex-col mt-4">
              <label htmlFor="poster" className="mb-1">
                Add Poster
              </label>
              <input
                onChange={handleChange}
                id="poster"
                name="poster"
                accept="image/png, image/jpeg"
                type="file"
              />
            </div>
          </div>
          <div className="w-full flex gap-1 items-end absolute bottom-0 p-2">
            <button
              onClick={() => {
                setIsAddEventModalOpen(false);
              }}
              className="bg-red-50 w-1/2 h-14 text-white capitalize flex justify-center items-center rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-green-50 w-1/2 h-14 text-white capitalize flex justify-center items-center rounded-lg"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddEvents;
